import Vue from 'vue';
import VueRouter from 'vue-router';
import { getToken, deleteToken } from '@/services/tokenService';
// eslint-disable-next-line import/extensions, import/no-unresolved, import/no-cycle
import store from '@/store';
import api from '@/plugins/axios';
import Home from '../views/Home';
import Client from '../views/Client';
import Login from '../views/Login';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      rule: ['isUser', 'isAdmin', 'isOperational']
    }
  },
  {
    path: '/client',
    name: 'Client',
    component: Client,
    meta: {
      rule: ['isClient', 'isUser', 'isAdmin', 'isOperational']
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      rule: ['isPublic']
    }
  },
  {
    path: '/403',
    name: 'Forbidden',
    component: () => import('@/views/Forbidden'),
    meta: {
      rule: ['isPublic']
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach(async (to, from, next) => {
  try {
    const token = await getToken();

    // Se está indo para o login e tem token, valida antes de entrar
    if (to.name === 'Login' && token) {
      try {
        await api.get('/user/logged');
        // Token válido, redireciona para home
        next({ name: 'Home' });
        return;
      } catch (error) {
        // Token inválido, desloga e continua para o login
        await deleteToken();
        await store.dispatch('Auth/logout');
        next();
        return;
      }
    }

    if (!token && to.matched.some((record) => record.name === 'Client')) {
      next();
    } else if (to.matched.some((record) => !record.meta.rule.includes('isPublic'))) {
      if (!token) {
        next({ name: 'Login' });
      } else if (store.getters['Auth/user']) {
        const userAccess = store.getters['Auth/access'];
        if (!userAccess || !to.matched[0].meta.rule.includes(userAccess)) {
          router.push('/403');
        } else {
          next();
        }
      } else {
        await store.dispatch('Auth/getUser').then(
          async () => {
            const userAccess = store.getters['Auth/access'];
            if (!userAccess || !to.matched[0].meta.rule.includes(userAccess)) {
              router.push('/403');
            } else {
              next();
            }
          },
          () => {
            next({ name: 'Login' });
          }
        );
      }
    } else {
      next();
    }
  } catch (error) {
    console.error('Router guard error:', error);
    next({ name: 'Login' });
  }
});

export default router;
